import type { Post } from '@/domain/posts/entities/post.entity'
import type { PostRepository } from '@/domain/posts/repositories/post_repository'
import { PostsRtkDatasource } from '../datasources/posts_rtk_datasource'

export class PostRepositoryImpl implements PostRepository {
  constructor(private readonly remote: PostsRtkDatasource = new PostsRtkDatasource()) {}

  async list(): Promise<Post[]> {
    const items = await this.remote.list()
    return items.map(item => ({
      id: item.id,
      content: item.content,
      imageUrl: item.imageUrl ?? undefined,
      postedBy: item.postedBy,
      createdAt: item.createdAt,
    }))
  }

  async delete(id: string): Promise<void> {
    await this.remote.delete(id)
  }
}

export const postRepository = new PostRepositoryImpl()
